import { observable } from "mobx";
import { Type } from "class-transformer";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargeValidityRequest {
  /**
   * If true - charge is valid from now on.
   */
  @observable
  hasImmediateValidity?: boolean;

  /**
   * Beginning date of charge validity (must be in future).
   */
  @observable
  @Type(() => Date)
  validSinceDate?: Date;

  @observable
  @Type(() => Date)
  _validUntilDate?: Date;

  @observable
  @Type(() => Date)
  _validUntilOverlap?: Date;

  @observable
  _proposedValidityExist?: boolean;
}
